import axios from 'axios'
import moment from 'moment'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import vue from 'vue'
import config from '../../../config'

export async function getLatestTemperatureHumidity(condition={}){
    let response={}
    let startTime = condition.startTime? encodeURIComponent(moment(condition.startTime).format().split('+')[0]) : null //2022-08-05T14:41:00+08:00 移除時區(+之後)

    // let queryArea = condition.scenicAreaId?condition.scenicAreaId.map(i=>`areas=${i}`).join(''):'';
    let queryTime = `&time=${startTime}`;

    try {
        response = await axios.get(`${config.eastCoastDataApi()}IotData/GetLatestTemperatureHumidity?${queryTime}`)


    } catch (err) {
        console.error('iisi getIotEvent: ', err)
        return response
    }
    
    Utils.setApiResponsSuccess(response)
    return response.data
}



